export enum PackagesType {
  Confort = "CON",
  ConfortPlus = "CON+",
  Parisienne = "PAR",
  Solidaire = "SOL",
  ProtectionJuridique = "PJ",
  Tourcoing = "TOU",
  Lilloise = "LIL",
  Grenobloise = "GRE",
  Cristolienne = "CRE",
  Etudiante = "ETU",
  Marseille = "MAR",
  Bailleur_Sociaux = "BSOL",
  // SA
  Tranquilite80 = "TRA80",
  Tranquilite65 = "TRA65",
  Securite = "SEC",
}
